import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

import { eduMap } from "../assets/educationImages/educationImages";

export default function EducationDegree() {
    const [degree, setDegrees] = useState([]);

    useEffect(() => {
        const fetchDegrees = async () => {
        try {
            const degreeRef = collection(db, "education");
            const snapshot = await getDocs(degreeRef);

            const degreeData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            }));

            setDegrees(degreeData);
        } catch (err) {
            console.error("Error fetching education:", err);
        }
        };

        fetchDegrees();
    }, []);

    return (
            <div className="educationDegrees">
                {degree.length === 0 ? (
                    <p>Loading education...</p>
                ) : (
                    degree.map((item) => (
                    <div key={item.id} className="educationDegree card">
                        <div>
                            <h3>{item.degree} - {item.school}</h3>
                            <div className="educationCard">
                                <div className="educationImage">
                                    <img
                                        src={eduMap[item.degreeName] || null}
                                        alt={item.degree}
                                    />
                                </div>
                                <div className="educationDetails">
                                    <p>{item.degree}, {item.major}, {item.minor}</p>
                                    <p className="educationYears">{item.years}</p>
                                    <p>{item.details}</p>
                                </div>
                                <div className="educationClasses">
                                    Classes: 
                                    {item.classes && item.classes.length > 0 && (
                                        <ul>
                                            {item.classes
                                                .filter(point => point && point.trim() !== "")
                                                .map((point, index) => (
                                                <li key={index}>{point}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div> 
                        </div>
                    </div>
                    ))
                )}
            </div>
    );
}